import { MemberEditTabSecurity } from '../../components/MemberEditTabSecurity/MemberEditTabSecurity';
import { type Member } from '../../models/member';

type Props = {
  member: Member;
};

export const MemberEditTabSecurityContainer = ({ member }: Props) => {
  return <MemberEditTabSecurity member={member} />;
};
